export const GET_PHARMACIES_GROUPS__REQUEST = 'USER_TYPE__GET_PHARMACIES_GROUPS__REQUEST'
export const GET_PHARMACIES_GROUPS__SUCCESS = 'USER_TYPE__GET_PHARMACIES_GROUPS__SUCCESS'
export const GET_PHARMACIES_GROUPS__FAILURE = 'USER_TYPE__GET_PHARMACIES_GROUPS__FAILURE'
